import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RepayCardPage } from './repay-card/repay-card.page';
import { RepayAchPage } from './repay-ach/repay-ach.page';
import { RepayCardPageRoutingModule } from './repay-card/repay-card-routing.module';
import { RepayAchPageRoutingModule } from './repay-ach/repay-ach-routing.module';
import { MasterHeaderModule } from '../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../master-footer/master-footer.module';
import { AddressDetailsPageModule } from '../../../address-details/address-details.module';
import { CustomInputModule } from '../../../common-components/custom-input/custom-input.module';

@NgModule({
  declarations: [
    RepayCardPage,
    RepayAchPage
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RepayCardPageRoutingModule,
    RepayAchPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    AddressDetailsPageModule,
    CustomInputModule
  ],
  exports: [
    RepayCardPage,
    RepayAchPage
  ]
})
export class RepayModule { } 